module.exports = __webpack_public_path__ + "static/ma-1-3ff97631bea77c73d89d8411b4a77f2c.png";